var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaHomepageTakeoverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-homepage-takeover-icon_svg__a",
    d: "M0 60h60.533V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.183 23.878c0 13.187 10.69 23.877 23.877 23.877s23.877-10.69 23.877-23.877S41.247 0 28.06 0 4.183 10.69 4.183 23.878",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-homepage-takeover-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-homepage-takeover-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-homepage-takeover-icon_svg__b)",
    d: "M9.913 32.302h5.73V19.886h-5.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.868 31.347h3.82V20.841h-3.82v10.506zm-1.91 1.91h7.64V18.931h-7.64v14.326z",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#ea-homepage-takeover-icon_svg__b)",
    d: "M45.252 59.045H7.048V33.258L26.15 17.976l19.102 15.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-homepage-takeover-icon_svg__b)",
    d: "M26.15 24.662l6.71 5.251 4.866-2.587-11.576-9.35L1.317 38.033l2.866 3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.206 60H6.092V39.307a.954.954 0 111.91 0V58.09h36.294v-4.776a.954.954 0 111.91 0V60z",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.003 43.207L0 37.869l26.149-21.12 12.176 9.833a.955.955 0 01-1.2 1.486L26.15 19.203 2.634 38.197 4.36 40.5 26.15 23.449l7.3 5.713a.954.954 0 11-1.177 1.503l-6.123-4.79L4.003 43.206z",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.892 39.466c0 5.538-4.49 10.028-10.028 10.028-5.539 0-10.029-4.49-10.029-10.028 0-5.539 4.49-10.029 10.029-10.029s10.028 4.49 10.028 10.029",
    fill: "#FEFEFE",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.864 30.392c-5.003 0-9.074 4.07-9.074 9.073s4.07 9.074 9.074 9.074c5.002 0 9.073-4.07 9.073-9.074 0-5.002-4.07-9.073-9.073-9.073m0 20.057c-6.057 0-10.984-4.927-10.984-10.984 0-6.056 4.927-10.983 10.984-10.983 6.056 0 10.983 4.927 10.983 10.983 0 6.057-4.927 10.984-10.983 10.984",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.752 39.337a.955.955 0 01-.942-1.12 7.133 7.133 0 015.481-5.74.954.954 0 11.418 1.864 5.229 5.229 0 00-4.018 4.206.956.956 0 01-.94.79M59.578 56.18a.952.952 0 01-.675-.28l-9.164-9.163a.956.956 0 011.35-1.35l9.164 9.162a.954.954 0 01-.675 1.63",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-homepage-takeover-icon_svg__b)",
    d: "M16.599 59.045h7.64V45.674H16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.554 58.09h5.73V46.629h-5.73v11.46zM15.644 60h9.55V44.718h-9.55V60z",
    fill: "#020303",
    mask: "url(#ea-homepage-takeover-icon_svg__b)"
  }))));
}
export default SvgEaHomepageTakeoverIcon;